import { Link } from 'react-router-dom';
import { categories, platforms } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-play-circle-fill text-xl text-white"></i>
                </div>
                <span className="text-xl font-heading text-white">小蓝视频</span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed">
                汇聚香蕉视频、糖豆视频、茄子视频、糖心视频、苹果视频、青青草视频等热门平台高清免费在线观看，不缓冲最新电影电视剧大全。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">视频分类</h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">合作平台</h4>
              <ul className="space-y-2.5">
                {platforms.map((p) => (
                  <li key={p.slug}>
                    <span className="text-sm text-background-400">{p.name}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">关于我们</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                    品牌介绍
                  </Link>
                </li>
                <li>
                  <a href="mailto:contact@xiaolanvideo.com" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                    联系我们
                  </a>
                </li>
                <li>
                  <span className="text-sm text-background-400">客服电话：400-888-6688</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-background-700">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-background-500">
                &copy; 2026 小蓝视频 XiaolanVideo.com 版权所有
              </p>
              <div className="flex items-center gap-4">
                <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors duration-200" rel="nofollow">
                  隐私政策
                </a>
                <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors duration-200" rel="nofollow">
                  服务条款
                </a>
                <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors duration-200" rel="nofollow">
                  版权声明
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}